import React from "react";
import "./Main.css";

export default function Main() {
    return (
            <div className="main-container" id="Services" data-aos="fade-left">
                <h2>Σχετικά με εμάς<span>.</span></h2>
                <div className="main-container-text">
                    Παρέχουμε διαρκή ενημέρωση για όλες τις μεταβαλλόμενες Λογιστικές, 
                    Φοροτεχνικές, Ξενοδοχειακές
                    και Συμβουλευτικές Υπηρεσίες σε ιδιώτες, εταιρείες και επιχειρήσεις.
                    Το γραφείο ξεκίνησε το 2009 με δυναμική ανάπτυξη και μεγάλη εμπειρία. 
                    Η επιτυχία του γραφείου βασίζεται στην ποιότητα των υπηρεσιών μας και στην 
                    εμπιστοσύνη των πελατών γεγονός που αποδεικνύεται από το ρυθμό ανάπτυξης των 
                    μικρών και μεσαίων επιχειρήσεων που συνεργάζονται μαζί μας.
                </div>
            </div>
    );
}